import { render } from "./icon_compartir.vue?vue&type=template&id=24408cf7"
import script from "./icon_compartir.vue?vue&type=script&lang=js"
export * from "./icon_compartir.vue?vue&type=script&lang=js"

import exportComponent from "/home/ppfernandez/vuejs/vue-pwa-petinder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__